import NotesTable from "./NotesTable";

const SafetyIssuesTable = (props) => (
  <NotesTable
    {...props}
    itemsKey="safety_issues"
    title="Safety Issues"
    columnTitle="Issue"
    addButtonLabel="Add a Safety Issue"
  />
);

export default SafetyIssuesTable;
